import { FileExporterService } from 'src/app/angularJS/services/file-exporting/file-exporter.service';
import { CatalogueService } from 'src/app/angularJS/services/catalogue/catalogue.service';

export class ProductCatalogueVersionsController {

  public static $inject = ['$stateParams', '$rootScope', 'catalogues', 'fileExporterService', 'catalogueService'];
  public catalogueVersions: Array<InterACT.Interfaces.Catalogues.Catalogue>;
  public catalogueId: string;

  constructor(
    $stateParams,
    private $rootScope,
    public catalogues: Array<InterACT.Interfaces.Catalogues.Catalogue>,
    private fileExporterService: FileExporterService,
    private catalogueService: CatalogueService
  ) {
    this.catalogueId = $stateParams.catalogueId;
    this.catalogueVersions = catalogues;
    $rootScope.showSpinner = false;
  }

  /**
   * Exports a copy of the catalogue to zip file with the name as the catalogue's scheme, description and version
   * @param catalogue the catalogue to export
   */
  public exportCatalogue = (catalogue: InterACT.Interfaces.Catalogues.Catalogue) => {
    const fileName = `${catalogue.scheme.abbreviation}-${catalogue.description}-${catalogue.version}`;
    this.$rootScope.showSpinner = true;
    this.catalogueService.getCatalogue(this.catalogueId, {
      expand: true,
      catalogueVersion: catalogue.version
    }).then((response: InterACT.Interfaces.Catalogues.Catalogue) => {
      this.$rootScope.showSpinner = false;
      this.fileExporterService.downloadZipFile(fileName, `${fileName}.json`, angular.toJson(response));
    });
  }
}
